import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import classnames from 'classnames';
import { createPortal } from 'react-dom';
import { useNeuroState, NeuroMessage, useDispatch, useProduct, } from '@ignitesales/neuro-application';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';
import useLookupInfo from '../../hooks/useLookupInfo';
import useSendToInsight from '../../hooks/useSendToInsight';
import useSubmittedProducts from '../../hooks/useSubmittedProducts';
import useActionOnSubmit from '../../hooks/useActionOnSubmit';

const ShoppingCartModal = ({ className, showMenu, setShowMenu, productsInCart }) => {
  const { user } = useNeuroState();
  const [loading, setLoading] = useState(false);
  const { lookupInfo, setLookupInfo, loadingCompanyInfo } = useLookupInfo();
  const { hasSentToInsight, onSendToInsightClicked } = useSendToInsight(lookupInfo, setLoading);

  const employee = user?.assignment?.employee;
  const branch = user?.assignment?.branch;
  const classes = classnames(className, 'header-menu-modal');
  const closeBtn = <ReactSVG src="/classpath/assets/images/icons/icon-close-menu.svg" />;
  const dispatch = useDispatch();
  const renderSpinner = () => <div className="summary-loading"><i className="fa fa-spinner fa-pulse fa-5x"></i></div>;

  const { saveSubmittedProducts } = useSubmittedProducts();
  const { openCreditCardLink } = useActionOnSubmit();

  const handleInsightClick = () => {
    setShowMenu(false);
    onSendToInsightClicked();
    openCreditCardLink();
  };

  const removeProductFromCart = (product, onSelectClick) => {
    onSelectClick();
  };

  return (
    <>
      <Modal
        className={classes}
        show={showMenu}
        onClose={() => setShowMenu(false)}
        closeBtn={closeBtn}
        nodeId="root">
        <div className="info-container">
          {loading && createPortal(renderSpinner(), document.getElementById('root'))}

          <div className="user-info">
            {employee && <h1 className="user-info__name">{`${employee.firstName} ${employee.lastName}`}</h1>}
            {branch && <h2 className="user-info__branch">{branch.name}</h2>}
          </div>
          <div className="products-title">
            <p><NeuroMessage id="summary.shoppingCart.productsTitle" /></p>
            <span>{productsInCart.length}</span>
          </div>
          <div className="products-list">
            {Object.entries(productsInCart.reduce((groupedProducts, product) => {
              const group = groupedProducts[product.groupType] || [];
              group.push(product);
              groupedProducts[product.groupType] = group;
              return groupedProducts;
            }, {})).map(([groupType, products]) => (
              <div key={groupType} className="product-group">
                <NeuroMessage id={groupType} className="product-group-type" />
                {products.map(product => {
                  const { onSelectClick } = useProduct(product);
                  return (
                    <div key={`${product.id}-product`} className="product">
                      <div className="product_name">
                        <span>{product.name}</span>
                      </div>
                      <button
                        className="remove-button"
                        onClick={() => removeProductFromCart(product.id, onSelectClick)}
                      />
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div className="menu-actions">
            <button className="btn insight" onClick={handleInsightClick} disabled={hasSentToInsight}>
              <NeuroMessage id="summary.page.cta" tagName="span" />
              <ReactSVG src="/classpath/assets/images/icons/arrow_forward.svg" />
            </button>
          </div>

        </div>
        <div className="iso-commerce">
          <ReactSVG src="/classpath/assets/images/iso-commerce.svg" />
        </div>
      </Modal>
    </>
  );
}

ShoppingCartModal.propTypes = {
  className: PropTypes.string,
  showMenu: PropTypes.bool,
  setShowMenu: PropTypes.func
};


export default ShoppingCartModal;